<template>
  <ModalSmall :title="t('account_delete_title')" @close="emit('close')">
    <div class="modal-body">
      <ul>
        <li>
          <p class="accent">{{ t('account_delete_sub_title_1') }}</p>
          <p>
            {{ t('account_delete_message_1') }}
          </p>
        </li>
        <li>
          <p class="accent">{{ t('count_delete_sub_title_2') }}</p>
          <p>{{ t('account_delete_message_2') }}</p>
        </li>
        <li>
          <p class="accent">{{ t('count_delete_sub_title_3') }}</p>
          <p>
            {{ t('account_delete_message_3') }}
          </p>
        </li>
        <li>
          <p>
            <i18n-t keypath="account_delete_button" scope="global">
              <template #button>
                <a @click="moveToSupportCenterPage">
                  {{ t('support_center') }}
                </a>
              </template>
            </i18n-t>
          </p>
        </li>
      </ul>
    </div>
    <div class="modal-footer">
      <ButtonProcess class="button-error" @click="onClickDeleteUser">
        {{ t('button_account_delete') }}
      </ButtonProcess>
    </div>
  </ModalSmall>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { deleteUserSelfService } from '@/api/apiService';
import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';
import ModalSmall from '@/components/shared/composite/ModalSmall.vue';
import { useLogin } from '@/composables/shared/useLogin';
import { useAdminStore } from '@/stores/admin';
import { useToastStore } from '@/stores/toast';
import { logoutSocialMobile } from '@/utils/authService';
import { isInCapacitorApp } from '@/utils/device';

const { t } = useI18n();
const adminStore = useAdminStore();
const toastStore = useToastStore();

const router = useRouter();

const emit = defineEmits<{
  close: [isAll?: boolean];
}>();

const { goToLoginPage } = useLogin();

const moveToSupportCenterPage = () => {
  router.push({ name: 'ss-contact' });
  emit('close', true);
};

// 계정 삭제하기 클릭 시
const onClickDeleteUser = async () => {
  const userId = adminStore.getPartnerEmployeeInfo.userId;
  const { success } = await deleteUserSelfService(userId);

  const isMobile = isInCapacitorApp();

  if (!success) {
    toastStore.error(t('ss_delete_user_fail'));
    emit('close');
    return;
  }

  if (isMobile) {
    toastStore.info(t('ss_delete_user_success'));
    await logoutSocialMobile();
    goToLoginPage();

    return;
  }

  localStorage.removeItem('authToken');
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('loginType');
  toastStore.info(t('ss_delete_user_success'));
  window.location.reload();
  window.location.replace('https://www.sconai.com/sconchat/home');
};
</script>

<style scoped lang="scss">
.modal-body {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  ul {
    list-style: none;
    margin: 0;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    background: var(--surface-gray-dim);
    border-radius: 8px;

    li {
      position: relative;
      padding-left: 1rem;

      &::before {
        content: '•';
        position: absolute;
        left: 0;
        top: 0.165rem;
      }
    }
  }
}

.modal-footer {
  margin-top: 1.5rem;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
